import React, { useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import AvatarEditor from 'react-avatar-editor';
import Dropzone from 'react-dropzone';

const Editor = ({ imageValue, imageId, updateImageData }) => {
  const [{ scale }, setChanges] = useState({
    scale: 1
  });

  const handleChange = useCallback(
    ({ target }) => {
      setChanges({ scale: Number(target.value) });
    },
    [setChanges]
  );
  const editorRef = useRef();
  const dpi = 2; // window.devicePixelRatio; // https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#value
  const border = 50;
  const base = 125;
  const height = (base + border) * dpi;
  const width = (base + border) * dpi;
  const delta = 150;

  const [image, setImage] = useState(null);

  const handleSave = () => {
    const img = editorRef.current.getImageScaledToCanvas().toDataURL('image/jpeg', 1.0);
    updateImageData(imageId, { image: img, ready: true }, '');
    setImage(null);
  };

  let avatarEditor = null;
  if (!imageValue.value) {
    avatarEditor = (
      <div className="columns">
        <div className="column is-narrow">
          <Dropzone noClick={Boolean(image)} onDrop={dropped => setImage(dropped[0])}>
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()} className="speaker-imge-row">
                <div className="avatar">
                  <AvatarEditor
                    ref={editorRef}
                    border={border}
                    className={`canvas-avatar-${imageId}`}
                    height={height}
                    image={image}
                    scale={scale}
                    style={{
                      height: `${base + border + delta}px`,
                      width: `${base + border + delta}px`
                    }}
                    width={width}
                  />
                  <div className="overlay" style={{ display: image ? 'none' : 'block' }}>
                    <i className="fa fa-file-image" />
                    <span
                      className="bold-text is-flex is-justify-content-center"
                      style={{ margin: '40px 0 0 0', color: 'gray' }}>
                      Use drag and drop or click here
                    </span>
                    <span className="is-flex is-justify-content-center" style={{ color: 'gray' }}>
                      Triggers camera on mobile devices
                    </span>
                  </div>
                </div>
                <input {...getInputProps()} />
              </div>
            )}
          </Dropzone>
        </div>
        <div className="column" style={{ display: image ? 'block' : 'none' }}>
          <div className="columns is-multiline">
            <div className="column is-full">
              <button
                className="button is-flex is-success is-medium is-rounded"
                onClick={handleSave}
                type="button">
                <span>Save photo</span>
              </button>
            </div>
            <label className="label column is-narrow" htmlFor="photoScale">
              Zoom photo
            </label>
            <div className="column">
              <input
                className="is-flex"
                id="scale"
                max="5"
                min="1"
                name="photoScale"
                onChange={handleChange}
                step="0.1"
                type="range"
                value={scale}
              />
            </div>
            {/* <span
              className={`upload-rules ${isValidSpeakerValue(imageId, 'photo') ? '' : ' has-error'
                }`}>
              Square dimensions i.e. 200x200, allowed types: .jpg, .jpeg, .png
            </span> */}
            <span className="photo-error">{imageValue.error}</span>
            <span className="column is-flex is-full">
              Center your image within the square frame using the mouse and save the cropped photo.
            </span>
          </div>
        </div>
      </div>
    );
  } else {
    avatarEditor = (
      <div className="speaker-imge-row">
        <img alt="" src={imageValue.value.image} />
        <button
          className="delete is-large remove-button"
          onClick={() => {
            updateImageData(imageId, '', '');
            setChanges({ scale: 1 });
          }}
          type="button">
          Remove
        </button>
      </div>
    );
  }
  return avatarEditor;
};

Editor.propTypes = {
  updateImageData: PropTypes.func.isRequired
};

export default Editor;
